var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6047 18.8792C12.3579 19.1264 12.0595 19.25 11.7098 19.25C11.36 19.25 11.0617 19.1264 10.8148 18.8792L3.09975 11.1545C2.96259 11.0172 2.87001 10.873 2.82201 10.7219C2.774 10.5708 2.75 10.4129 2.75 10.2481V3.98596C2.75 3.6289 2.86658 3.33365 3.09975 3.10019C3.33292 2.86673 3.62781 2.75 3.98441 2.75H10.2388C10.4034 2.75 10.568 2.77403 10.7325 2.8221C10.8971 2.87016 11.048 2.96286 11.1852 3.10019L18.8591 10.7837C19.1197 11.0446 19.25 11.3502 19.25 11.7004C19.25 12.0506 19.1197 12.3561 18.8591 12.617L12.6047 18.8792ZM11.7612 18.0346L18.0156 11.7725L10.2388 3.98596H3.98441V10.2481L11.7612 18.0346ZM6.14464 7.19944C6.43267 7.19944 6.68298 7.09301 6.89557 6.88015C7.10817 6.66729 7.21446 6.41667 7.21446 6.12828C7.21446 5.83989 7.10817 5.58926 6.89557 5.3764C6.68298 5.16355 6.43267 5.05712 6.14464 5.05712C5.85661 5.05712 5.6063 5.16355 5.3937 5.3764C5.18111 5.58926 5.07481 5.83989 5.07481 6.12828C5.07481 6.41667 5.18111 6.66729 5.3937 6.88015C5.6063 7.09301 5.85661 7.19944 6.14464 7.19944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.41b35180405060c53f158bda17b9ee5f.svg";
export { ForwardRef as ReactComponent };